import { render, staticRenderFns } from "./VentasPorPeriodo.vue?vue&type=template&id=2a3ea20e&scoped=true&"
import script from "./VentasPorPeriodo.vue?vue&type=script&lang=js&"
export * from "./VentasPorPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./VentasPorPeriodo.vue?vue&type=style&index=0&id=2a3ea20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ea20e",
  null
  
)

export default component.exports